import { useState } from "react";
import { faqs } from "@/mocks/data";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="bg-background-100" aria-label="常见问题">
      <div className="mx-auto w-full max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于漫画岛，你可能想知道的</p>
        </div>
        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-heading text-base font-bold text-foreground-900">{f.q}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-primary-600 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}